export enum StepsEnum {
  INTRODUCTION = 'introduction',
  BACKGROUND = 'background',
  COLLEGE_COSTS = 'collegeCosts',
  COLLEGE_FUNDING = 'collegeFunding',
  COLLEGE_ROI_REPORT = 'collegeRoiReport'
}
